import { TextField, FormControl, InputLabel, InputAdornment, Stack } from "@mui/material"
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { OPTIONS_VARIANTS } from "../utils/structures";
import Confirmation from "./Confirmation";
import Helper from "./Helper";
import { useEffect, useState } from "react"

export default function ProductSubOption(props) {

    const [price, setPrice] = useState(0)
    const [name, setName] = useState(0)
    const [calories, setCalories] = useState('')
    const [unitsLimit, setUnitsLimit] = useState('')

    const [isVisible, setIsVisible] = useState(true)
    const [showConfirmation, setShowConfirmation] = useState(false)

    const savePrice = newPrice => {
        const newSubOption = { ...props.subOption, price: parseFloat(newPrice) }
        props.updateSubOption(props.optionIndex, props.subOptionIndex, newSubOption)
    }

    const saveName = newName => {
        const newSubOption = { ...props.subOption, name: newName }
        props.updateSubOption(props.optionIndex, props.subOptionIndex, newSubOption)
    }

    const saveCalories = newCalories => {
        const newSubOption = { ...props.subOption, calories: parseInt(newCalories) }
        props.updateSubOption(props.optionIndex, props.subOptionIndex, newSubOption)
    }

    const saveUnitsLimit = newLimit => {
        const newSubOption = { ...props.subOption, limit: parseInt(newLimit) }
        props.updateSubOption(props.optionIndex, props.subOptionIndex, newSubOption)
    }

    const toggleVisible = () => {
        const newSubOption = { ...props.subOption, visible: !isVisible }

        setIsVisible(!isVisible)

        props.updateSubOption(props.optionIndex, props.subOptionIndex, newSubOption)
    }

    useEffect(() => {
        setPrice(props.subOption.price)
        setCalories(props.subOption.calories)
        setName(props.subOption.name ? props.subOption.name : '')

        setIsVisible(props.subOption.visible)
        setUnitsLimit(props.subOption.limit)
    }, [props.subOption])

    return (
        <>
            <Confirmation
                action={() => { props.removeSubOption(props.optionIndex, props.subOptionIndex) }}
                open={showConfirmation}
                setOpen={setShowConfirmation}
                title={"Estas seguro que deseas eliminar esta opción?"}
                description={"Perderas la información de esta opción"}
                actionMsg={"Eliminar"}
                rejectMsg={"Cancelar"}
            />

            <Stack direction='row'>
                <FormControl variant="outlined" sx={{ width: '100%' }}>
                    <InputLabel>Nombre de la Opción</InputLabel>
                    <OutlinedInput
                        inputProps={{ 'aria-label': 'search google maps' }}
                        value={name}
                        onChange={e => {
                            const inputVal = e.target.value

                            if (inputVal.length < 100) {
                                setName(inputVal)
                                saveName(inputVal)
                            }
                        }}
                        style={isVisible ? {} : { textDecoration: 'line-through' }}
                        endAdornment={
                            <InputAdornment position="end">

                                <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions"
                                    onClick={() => toggleVisible()}
                                >
                                    {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                </IconButton>

                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <IconButton onClick={() => setShowConfirmation(true)} color="error">
                                    <DeleteForeverIcon />
                                </IconButton>

                            </InputAdornment>
                        }
                        label="Nombre de la Opción"
                    />
                    <FormHelperText>Maximo 100 caracteres</FormHelperText>
                </FormControl>

                <Helper
                    text='Puedes ocultar una opción temporalmente para que deje ser visible pero sin ser eliminada o puedes eliminarla permanentemente'
                    style={{ marginBottom: '20px' }}
                />
            </Stack>

            <Stack direction='row' justifyContent='space-between' flexWrap='wrap'>
                <FormControl variant="outlined" sx={{ m: 1, flexGrow: '1' }}>
                    <InputLabel>Precio extra</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-weight"
                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        onChange={e => {
                            const inputVal = e.target.value.replace(',', '.');
                            const regex = /^(\d*)([,.]\d{0,2})?$/;

                            if (inputVal === "") {
                                setPrice(0)
                                savePrice(0)

                            } else if (regex.test(inputVal)) {
                                const val = inputVal.at(0) === '0' && inputVal.length > 1 ? inputVal.slice(1,) : inputVal
                                setPrice(val)
                                savePrice(val)
                            }
                        }}
                        value={price}
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                            'aria-label': 'weight',
                        }}
                        label="Precio extra"
                    />
                    <FormHelperText id="outlined-weight-helper-text">Precio extra, puede ser 0 si no hay cambios en el precio</FormHelperText>
                </FormControl>

                <FormControl variant="outlined" sx={{ m: 1, flexGrow: '1' }}>
                    <InputLabel>Calorias</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-weight"
                        endAdornment={<InputAdornment position="end">Kcal</InputAdornment>}
                        onChange={e => {
                            const regex = /^[0-9]*$/
                            const inputVal = e.target.value

                            if (inputVal === "") {
                                setCalories(0)
                                saveCalories(0)

                            } else if (regex.test(inputVal)) {
                                const val = inputVal.at(0) === '0' && inputVal.length > 1 ? inputVal.slice(1,) : inputVal
                                setCalories(val)
                                saveCalories(val)
                            }
                        }}
                        value={calories}
                        placeholder="Calorias"
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                            'aria-label': 'weight',
                        }}
                        label="Calorias"
                    />
                    <FormHelperText id="outlined-weight-helper-text">Calorias extra aproximadas (Opcional)</FormHelperText>
                </FormControl>

                {props.option.type === OPTIONS_VARIANTS.addUnits ?
                    <Stack direction='row' flexGrow={1} sx={{ m: 1 }}>
                        <TextField
                            sx={{ flexGrow: '1' }}
                            label="Cantidad máxima"
                            variant="outlined"
                            helperText={<>Máxima cantidad de unidades que<br />se pueden agregar de esta opción</>}
                            value={unitsLimit}
                            required
                            onChange={e => {
                                const regex = /^[0-9]*$/
                                const inputVal = e.target.value

                                if (inputVal === "") {
                                    setUnitsLimit(0)
                                    saveUnitsLimit(0)

                                } else if (regex.test(inputVal)) {
                                    const val = inputVal.at(0) === '0' && inputVal.length > 0 ? inputVal.slice(1,) : inputVal

                                    setUnitsLimit(val)
                                    saveUnitsLimit(val)
                                }
                            }}
                        />

                        <Helper
                            text='Puedes dejar esta opción en 0 si no quieres especificar un límite particular para esta opción'
                            style={{ marginBottom: '20px' }}
                        />
                    </Stack> : null}

            </Stack>

            <Divider sx={{ m: 2 }} />
        </>
    )

}